<ng-content><!-- Title goes here if provided --></ng-content>
<div *ngFor="let validationError of itemFG | getAllValidationErrors" role="alert" class="row">
  <div class="col-md-3 col-sm-4">
    <strong>{{validationError.field}}:</strong>
  </div>
  <div class="col-md-9 col-sm-8">
    {{validationError.errorMessage}}
  </div>
</div>
